import { useApolloClient } from '@apollo/client'
import { useGraphqlFetchAndCache } from "@mostrans/web-components/hooks/useGraphqlFetchAndCache"
import { MasterTestimonialAtom } from './TestimonialAtoms'
import { getMasterTestimoni } from './TestimonialQueries'

export const useGetMasterTestimoni = ({ startDate, endDate }) => {
    const client = useApolloClient()
    return useGraphqlFetchAndCache({
        atom: MasterTestimonialAtom,
        initialValue: [],
        getData: (param) => getMasterTestimoni(client, param),
        variables: { startDate, endDate }
    })
}
